import { GithubIcon } from './GithubIcon';

/**
 * author: Contributors
 * id 5C6175DD-8549-4004-AB77-A545D721A0DE
 * name github
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/github.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const MicrosoftGithubIcon = GithubIcon;
export default MicrosoftGithubIcon